import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { VipinfoEditColorDisplay } from '../../models/vipinfo-edit-colors.model';
import {
  VipDefaultButton,
  VipLinkButton,
} from '@3ddv/ngx-sites-builder-lib/lib/workflows/interface/vipinfo/models/vipinfo.model';
import { VWVipButton } from '../../models/vipinfo.model';

@Component({
  selector: 'app-vipinfo-colors',
  templateUrl: './vipinfo-colors.component.html',
  styleUrls: ['./vipinfo-colors.component.scss'],
})
export class VipinfoColorsComponent {
  @Input() vipInfoEditColorsDisplay: { [key: string]: VipinfoEditColorDisplay[] };
  @Output() colorChange: EventEmitter<{ category: string; property: string; color: string }>;
  @Input() defaultButton: VipDefaultButton;
  @Input() linkButton: VipLinkButton;
  @Input() set vipButtons(buttons: VWVipButton[]) {
    this._mybtns = buttons;
  }
  private _mybtns: VWVipButton[];

  constructor() {
    // initialize variables
    this.colorChange = new EventEmitter<{ category: string; property: string; color: string }>();
  }

  hasDefaultButton(): boolean {
    return this._mybtns.some(button => button.type === 'button');
  }

  hasLinkButton(): boolean {
    return this._mybtns.some(button => button.type === 'link');
  }

  onColorChange(category: string, property: string, color: any): void {
    this.colorChange.emit({ category, property, color });
  }
}
